@import "src/styles/common/_colors.scss";

.countLabel {
    border-left-width: 0.5px;
    padding-left: 0.5rem;
    height: 30px;
    display: flex;
    align-items: center;
    color: $description-color;
    border-left-style: solid;
    border-color: $description-color;
}
.reportListContainer {
    gap: 1rem;
    padding-top: 0.625rem;
    height: 100%;
    .radioButtonGroup {
        gap: 0;
        margin-left: -0.5rem;
    }
    .multiSingleSelection {
        flex-direction: column;
    }
    .reportListWrapper {
        height: 100%;
        .reportPanel {
            height: 100%;
            .panelList {
                background: $gray;
                height: calc(100% - 120px);
                overflow-y: visible !important;
                display: flex;
                flex-direction: column;
                border: 1px solid $black;
                .panelListInner {
                    height: 100%;
                    position: relative;
                    .reportListHeader {
                        border-bottom: 1px solid $orientation-icon-color;
                        display: flex;
                        gap: 1rem;
                        height: 30px;
                        align-items: center;
                        &.noBorder {
                            border-bottom: none;
                        }
                    }
                    .reportListBody {
                        max-height: 90%;
                        overflow-y: scroll;
                    }
                }
                .emptyMessage {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex: 1;
                }
            }
            .reportActionsWrapper {
                padding: 0.625rem 0;
                width: 100%;
            }
        }
    }
    .searchHighlight {
        background-color: $text-highlight;
        color: $white;
    }
}
